import styled from "styled-components"
import { Colors } from 'styles/app-styles'

interface ModalProps {
  height?: number,
  show: boolean,
  width?: number
}

interface ModalContentProps {
  scrollY?: boolean
}

export const Modal_s: any = styled.div<ModalProps>`
  align-items: center;
  background-color: rgba(0,0,0,0.4);
  display: ${props => props.show ? 'flex' : 'none'};
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 900;
  > div {
    position: absolute;
    top: 205px;
    background-color: ${Colors.white};
    height: ${(props) => props.height  ? `${props.height}px` : 'auto'};
    width: ${(props) => props.width ? `${props.width}px` : 'auto'};
  }
  .calc-download-icon .st0 {
    fill: #082141;
  }
`

export const ModalContent_s = styled.div<ModalContentProps>`
  overflow: auto;
  padding: 15px;
  ${(props) => props.scrollY && 'overflow-y: scroll;'}
  > span { text-wrap: wrap; }
`

export const ModalTitle_s = styled.div`
  background: ${Colors.inputFocus};
  color: ${Colors.darkDenim};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-family: 'Roboto-Light',sans-serif;
  height: 30px;
  justify-content: space-between;
  line-height: 20px;
  padding: 5px 8px;
  #downloadTooltipTarget {
    cursor: pointer;
    height: 18px;
    width: 18px;
  }
  svg {
    height: 16px;
    width: 16px;
  }
  svg, .st0, .r-svg {
    fill: ${Colors.darkDenim};
  }
  ${(props) => props['closeIconWidth'] && `a { width: ${props['closeIconWidth']}px; }`}
`

export const MultipartTitle_s = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
`

export const PromptRow_s = styled.div`
  position: sticky;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  height: 50px;
  width: 100%;
  bottom: 0px;
  left: 0px;
  padding: 10px 15px;
  background-color: white;
`

export const StyledSelect = styled.select`
  /* min-width: 100%; */
  width: 320px;
  font-size: small;
  height: 30px;
`

export const SelectRow = styled.div`
  text-align: center;
`

export const LabelSpan = styled.span`
  font-size: small;
  padding-top: 0.3em;
  margin-right: 5px;
`

export const ValidationErrorTable = styled.div`
  table {
    border-spacing: 0;
    color: ${Colors.blackPearl};
    font-size: 14px;
    width: 100%;
    tr { height: 30px; }
    thead {
      color: ${Colors.darkDenim};
      padding-bottom: 4px;
      th {
        border-bottom: 2px solid ${Colors.towerGrey};
        font-weight: 400;
        text-align: left;
      }
    }
    tbody {
      td { border-bottom: 1px solid ${Colors.towerGrey} !important; }
      tr:nth-of-type(even){ background-color: ${Colors.inputFocus}; }
    }
  }
`
